module.exports = __webpack_public_path__ + "static/media/step02.996b21ed.png";